import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Col } from 'reactstrap';
import { momentToString } from 'src/share/utils/utils';
import { getContactInformation } from 'src/share/utils/formatContactInfo';

export const ChildInfoMatch = ({ caseInfo, childInfo }) => {
  const { caseId, missingDate, openDate, state, city, country, contactInformation, circumstances } = caseInfo;
  const { fullName, sex, birthDate } = childInfo;
  return (
    <Col md={5}>
      <div className="child-info white-background">
        <div className="main-header">
          <h1 className="name label">{fullName}</h1>
          <p className="subFont"><label>Case ID:</label>{caseId || 'unknown'}</p>
        </div>
        <div className="case-data">
          <p><label>Birthdate:</label>{birthDate ? momentToString(birthDate) : 'unknown'}</p>
          <p><label>Sex:</label>{sex || 'unknown'}</p>
        </div>
        <div className="case-data">
          <p><label>Missing since:</label>{missingDate ? momentToString(missingDate) : ''}</p>
          <p><label>Case open date:</label>{openDate ? momentToString(openDate) : ''}</p>
          <p><label>Location:</label>{`${state ? state + ', ' : ''}${city ? city + ', ' : ''}${country || ''}`}</p>
          <p><label className="full-line">Contact info:</label></p>
          <div className="long-text">
            {contactInformation ? ReactHtmlParser(getContactInformation(contactInformation)) : 'unknown'}
          </div>
          <p><label className="full-line">Missing circumstances:</label></p>
          <p className="long-text">{circumstances}</p>
        </div>
      </div>
    </Col>
  )
}